import React, { Component } from "react";
import FadeIn from "react-lazyload-fadein";
import WithConsumer from '../../context/WithConsumer';


export default class Image extends Component {
	
	render () {
		
		let src 		= this.props.src;
		let srcset 		= this.props.srcset;
		let imgWidth 	= this.props.imgWidth;
		let imgHeight	= this.props.imgHeight;
				
		if (src && srcset) {
	         
		    return (
		        	
				<div className="c-image">
	        		<FadeIn duration={500} once={true}>
						{onload => (
							<img
								alt={""} 
								src={src} 
								srcSet={srcset} 
								onLoad={function(evt){evt.currentTarget.closest('.c-image').classList.add('state-loaded');}}
							/>
						)}
					</FadeIn>
	        	</div>

			)
			
		} else {
			
			return null;
		
		}
	}
}
